// Pricing mode configurations
export const PRICING_MODES = {
  BASIC: "basic",
  ADVANCED: "advanced",
}

// Environment configurations (chat platform)
export const ENVIRONMENTS = {
  WEBFLOW: "webflow", // Uses HubSpot chat
  SAAS: "saas", // Uses Crisp chat
}

// Default configuration
export const defaultConfig = {
  mode: PRICING_MODES.BASIC, // Current mode by default
  environment: ENVIRONMENTS.SAAS, // Default to SaaS environment
  // Mode will be switchable for future testing
}

// Period configurations
export const PERIODS = {
  MONTHLY: "mensuel",
  ONE_YEAR: "1an",
  TWO_YEARS: "2ans",
}

// Period multipliers for price calculation
export const PERIOD_MULTIPLIERS = {
  [PERIODS.MONTHLY]: 1,
  [PERIODS.ONE_YEAR]: 10,
  [PERIODS.TWO_YEARS]: 18,
}

// Saved months per period
export const PERIOD_SAVED_MONTHS = {
  [PERIODS.ONE_YEAR]: 2,
  [PERIODS.TWO_YEARS]: 6,
}

// Period offer texts
export const PERIOD_OFFERS = {
  [PERIODS.ONE_YEAR]: "2 mois OFFERTS",
  [PERIODS.TWO_YEARS]: "6 mois OFFERTS",
}

// Period options for selector component
export const PERIOD_OPTIONS = [
  { value: PERIODS.MONTHLY, label: "Mensuel" },
  { value: PERIODS.ONE_YEAR, label: "1 an" },
  { value: PERIODS.TWO_YEARS, label: "2 ans" },
]

// Initial state configurations per mode
export const INITIAL_VALUES = {
  [PRICING_MODES.BASIC]: {
    socialAccounts: 10,
    users: 5,
    sources: 10,
  },
  [PRICING_MODES.ADVANCED]: {
    socialAccounts: 10,
    users: 5,
    sources: 10,
  },
}

export default {
  PRICING_MODES,
  ENVIRONMENTS,
  defaultConfig,
  PERIODS,
  PERIOD_MULTIPLIERS,
  PERIOD_SAVED_MONTHS,
  PERIOD_OFFERS,
  PERIOD_OPTIONS,
  INITIAL_VALUES,
}
